import React, { useState, useEffect, useRef, useCallback } from "react";

import { MdEvent } from "react-icons/md";

import DashboardGreeting from "../DashboardGreeting";

import AddIcon from "../../assets/images/addIcon.svg";
import { useStateContext } from "../../contexts/ContextProvider";

import ArrowIcon from "../../assets/images/arrow-right-up.svg";

import { Link, redirect } from "react-router-dom";

import NewLeaveReq from "../../assets/images/newLeaveReq.svg";
import ApprovedReq from "../../assets/images/approvedReq.svg";
import RejectedReq from "../../assets/images/rejectedReq.svg";
import PendingReq from "../../assets/images/pendingReq.svg";
import EventIcon from "../../assets/images/event-Icon.svg";

import CakeIcon from "../../assets/images/cake2.svg";

import "../hr.css";

import Select from "react-select";

import { Calendar as MonthCalendar } from "primereact/calendar";
import "primereact/resources/themes/lara-light-cyan/theme.css";

import moment from "moment";

import { Doughnut } from "react-chartjs-2";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";
import AddEvent from "../common/AddEvent";
import SendWish from "../common/SendWish";
import DashboardService from "../../services/dashboard.service";
import { Flex } from "antd";
Chart.register(ArcElement, Tooltip, Legend);

const HRDashboard = ({ user }) => {
  const navHeading = "Welcome to Leave Management!";

  const elementRef = useRef(null);

  const {
    event,
    setEvent,
    sendWish,
    setSendWish,
    events,
    locations,
  } = useStateContext();

  const currentDate = new Date();
  const maxDate = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  );

  const [date, setDate] = useState();
  const [year, setYear] = useState();

  // const [details, setDetails] = useState({
  //   month: moment(new Date(date)).format("M"),
  //   year: moment(new Date(date)).format("YYYY"),
  // });

   const [details, setDetails] = useState({
     month: "",
     year: "",
   });

  const [leaveRequest, setLeaveRequest] = useState({
    newRequest: "",
    approvedRequest: "",
    pendingRequest: "",
    rejectedRequest: "",
    total: "",
  });

  const initialData = {
    keys: [],
    data: [],
  };

  const [attendanceCount, setAttendanceCount] = useState({ initialData });
  const [attendanceCountAll, setAttendanceCountAll] = useState({ initialData });
  const [totalEmpLocation, setTotalEmpLocation] = useState("");
  const [totalEmpAllLocation, setTotalEmpAllLocation] = useState("");
  const [selectedLocation, setSelectedLocation] = useState({
    label: "Pune",
    value: "25",
  });

  const fetchAttandanceCountLocationWise = useCallback(() => {
    const payload = {
      location: selectedLocation.label,
    };
    DashboardService.getAttendeceCount(payload)
      .then((resp) => {
        if (resp.data) {
          setTotalEmpLocation(resp.data.totalEmp);
          const attendanceCount = Object.entries(resp.data);
          const filteredAttendanceCount = attendanceCount.filter(
            (item) => item[0] !== "location" && item[0] !== "totalEmp"
          );

          // console.log("attendanceCount", filteredAttendanceCount)

          setAttendanceCount({
            keys: filteredAttendanceCount,
            data:
              filteredAttendanceCount &&
              filteredAttendanceCount.map((item) => item[1]),
          });
        }
      })
      .catch((e) => console.log(e));
  }, [selectedLocation.label]);

  const fetchAttandanceCountAllLocation = () => {
    const payload = {};

    DashboardService.getAttendeceCount(payload)
      .then((resp) => {
        if (resp.data) {
          setTotalEmpAllLocation(resp.data.totalEmp);
          const attendanceCount = Object.entries(resp.data);
          const filteredAttendanceCount = attendanceCount.filter(
            (item) => item[0] !== "location" && item[0] !== "totalEmp"
          );

          setAttendanceCountAll({
            keys: filteredAttendanceCount,
            data:
              filteredAttendanceCount &&
              filteredAttendanceCount.map((item) => item[1]),
          });
        }
      })
      .catch((e) => console.log(e));
  };

  const handleChange = (option) => {
    setSelectedLocation(option);
  };

  useEffect(() => {
    fetchAttandanceCountLocationWise();
  }, [fetchAttandanceCountLocationWise]);

  useEffect(() => {
    fetchAttandanceCountAllLocation();
  }, []);

  const fetchLeaveReqCount = useCallback((payload) => {
    DashboardService.getLeaveReqCount(payload)
      .then((resp) => {
        setLeaveRequest(resp.data);
      })
      .catch((e) => console.log(e));
  }, []);

  useEffect(() => {
    if (user.role === "1" || user.role === "4") {
      const payload = {
        month: null,
        year: null,
      };
      fetchLeaveReqCount(payload);
    }
  }, [fetchLeaveReqCount, user]);

  const handleDateChange = (e) => {
    setDate(e.value);

    if (!e.value) {
      // Clear filter logic
      setDetails({
        month: null,
        year: null,
      });
      // Optionally, fetch unfiltered leave request count
      if (user.role !== "1" || user.role !== "4") {
        fetchLeaveReqCount({ month: null, year: null });
      }
      return;
    }

    const month = moment(new Date(e.value)).format("M");
    const year = moment(new Date(e.value)).format("YYYY");

    const payload = {
      month: month,
      year: details.year ? details.year : year,
    };
    if (user.role !== "1" || user.role !== "4") {
      fetchLeaveReqCount(payload);
    }

    setDetails((prevState) => ({
      ...prevState,
      month: month,
    }));
  };

  const handleYearChange = (e) => {
    setYear(e.value);

     if (!e.value) {
      // Clear filter logic
      setDetails({
        month: null,
        year: null,
      });
      // Optionally, fetch unfiltered leave request count
      if (user.role !== "1" || user.role !== "4") {
        fetchLeaveReqCount({ month: null, year: null });
      }
      return;
    }

    const year = moment(new Date(e.value)).format("YYYY");
    
     const payload = {
      month: details.month ? details.month : null,
      year: year,
    };
    if (user.role !== "1" || user.role !== "4") {
      fetchLeaveReqCount(payload);
    }

    setDetails((prevState) => ({
      ...prevState,
      year: year,
    }));


  }

  const data = {
    labels: ["Present", "Absent", "On Leave", "Late Mark", "Half Day", "WHF"],
    datasets: [
      {
        label: "Today's Attendance",
        data: attendanceCount.data,
        backgroundColor: [
          "rgba(45, 206, 137, 1)",
          "rgba(255, 0, 0, 1)",
          "rgba(249, 133, 133, 1)",
          "rgba(254, 224, 105, 1)",
          "rgba(255, 192, 103, 1)",
          "rgba(246, 60, 60, 1)",
        ],
        borderWidth: 2,
        borderRadius: 4,
      },
    ],
  };

  const data2 = {
    labels: ["Present", "Absent", "On Leave", "Late Mark", "Half Day", "WHF"],
    datasets: [
      {
        label: "Today's Attendance",
        data: attendanceCountAll.data,
        backgroundColor: [
          "rgba(45, 206, 137, 1)",
          "rgba(255, 0, 0, 1)",
          "rgba(249, 133, 133, 1)",
          "rgba(254, 224, 105, 1)",
          "rgba(255, 192, 103, 1)",
          "rgba(246, 60, 60, 1)",
        ],
        borderWidth: 2,
        borderRadius: 4,
      },
    ],
  };

  const options = {
    cutout: 65,
    plugins: {
      title: {
        display: false,
      },
      legend: {
        display: false,
      },
    },
    responsive: true,
  };

  const createTextCenterPlugin = (text) => ({
    id: "textCenter",
    beforeDraw: (chart) => {
      // console.log("text", text);
      const ctx = chart.ctx;
      const width = chart.width;
      const height = chart.height;
      ctx.restore();
      ctx.font = "600 20px Jost";
      ctx.fillStyle = "rgba(110, 98, 132, 1)";
      ctx.textBaseline = "middle";

      const textX = Math.round((width - ctx.measureText(text).width) / 2);
      const textY = height / 2;

      ctx.fillText(text, textX, textY);
      ctx.save();
    },
  });

  return (
    <>
      <div className="dashboard-container hr">
        <div ref={elementRef}>
          <DashboardGreeting navHeading={navHeading} user={user} />
          <div className="filterBar mb-3 d-flex justify-content-between">
            <div className="heading arrow-flex">
              <span>Leave Request Stats</span>
              {user.role === "1" || user.role === "4" ? (
                <Link to={"/leaveRequest"}>
                  <span className="arrow">
                    <img src={ArrowIcon} alt="" />
                  </span>
                </Link>
              ) : (
                <></>
              )}
            </div>
            <div className="topbar">
              <div className="new-calendar-type flex justify-content-center month-year">
                <Flex gap={10}>
                  <MonthCalendar
                    value={date}
                    onChange={handleDateChange}
                    view="month"
                    placeholder="Select Month"
                    dateFormat="MM"
                    style={{ width: "100%" }}
                    showIcon
                    showButtonBar
                    yearNavigator={false}
                    monthNavigator={true}
                    panelClassName="month-only-calendar"
                  />
                  <MonthCalendar
                    value={year}
                    onChange={handleYearChange}
                    view="year"
                    placeholder="Select Year"
                    dateFormat="yy"
                    style={{ width: "100%" }}
                    showIcon
                    maxDate={maxDate}
                    showButtonBar
                  />
                </Flex>
              </div>
              {user.role !== "4" ? (
                <>
                  <div className="action">
                    <button
                      className="apply"
                      onClick={(e) => {
                        setEvent(true);
                      }}
                    >
                      <span>
                        <img src={AddIcon} alt="add event" />
                      </span>
                      <span>Add Event</span>
                    </button>
                  </div>
                </>
              ) : null}
            </div>
          </div>
        </div>

        <div>
          <div className="emp-stats">
            <div className="monthly mb-3">
              <div className="d-flex mb-3"></div>
              <div className="list">
                <div className="item">
                  <Link to={"/leaveRequest"} state={{ redirectIndex: 4 }}>
                    <div className="flex">
                      <div className="text">
                        <span>New</span>
                        <span className="count">{leaveRequest.newRequest}</span>
                      </div>
                      <div className="icon">
                        <img src={NewLeaveReq} alt="" />
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="item">
                  <Link to={"/leaveRequest"} state={{ redirectIndex: 2 }}>
                    <div className="flex">
                      <div className="text">
                        <span>Approved</span>
                        <span className="count">
                          {leaveRequest.approvedRequest}
                        </span>
                      </div>
                      <div className="icon">
                        <img src={ApprovedReq} alt="" />
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="item">
                  <Link to={"/leaveRequest"} state={{ redirectIndex: 3 }}>
                    <div className="flex">
                      <div className="text">
                        <span>Rejected</span>
                        <span className="count">
                          {leaveRequest.rejectedRequest}
                        </span>
                      </div>
                      <div className="icon">
                        <img src={RejectedReq} alt="" />
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="item">
                  <Link to={"/leaveRequest"} state={{ redirectIndex: 1 }}>
                    <div className="flex">
                      <div className="text">
                        <span>Pending</span>
                        <span className="count">
                          {leaveRequest.pendingRequest}
                        </span>
                      </div>
                      <div className="icon">
                        <img src={PendingReq} alt="" />
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="item">
                  <Link to={"/leaveRequest"} state={{ redirectIndex: 0 }}>
                    <div className="flex">
                      <div className="text">
                        <span>Total</span>
                        <span className="count">{leaveRequest.total}</span>
                      </div>
                      <div className="icon">
                        {/* <img src={TotalLeaveReq} alt="" /> */}
                        <span>
                          <svg
                            version="1.1"
                            baseProfile="basic"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            width="70"
                            height="70"
                            viewBox="0 0 71 71"
                            xmlSpace="preserve"
                          >
                            <path
                              fill="none"
                              stroke="#3B82F6"
                              strokeWidth="4.4"
                              strokeLinecap="round"
                              d="M59.2,41.4H8.9"
                            />
                            <path
                              fill="none"
                              stroke="#3B82F6"
                              strokeWidth="4.4"
                              strokeLinecap="round"
                              d="M32.5,53.2H8.9"
                            />
                            <line
                              fill="none"
                              stroke="#3B82F6"
                              strokeWidth="4.4"
                              strokeLinecap="round"
                              x1="8.9"
                              y1="17.8"
                              x2="39.9"
                              y2="17.8"
                            />
                            <line
                              fill="none"
                              stroke="#3B82F6"
                              strokeWidth="4.4"
                              strokeLinecap="round"
                              x1="59.2"
                              y1="17.8"
                              x2="52.5"
                              y2="17.8"
                            />
                            <line
                              fill="none"
                              stroke="#3B82F6"
                              strokeWidth="4.4"
                              strokeLinecap="round"
                              x1="59.2"
                              y1="29.6"
                              x2="28.1"
                              y2="29.6"
                            />
                            <line
                              fill="none"
                              stroke="#3B82F6"
                              strokeWidth="4.4"
                              strokeLinecap="round"
                              x1="8.9"
                              y1="29.6"
                              x2="15.5"
                              y2="29.6"
                            />
                            <line
                              fill="none"
                              stroke="#3B82F6"
                              strokeWidth="4.4"
                              strokeLinecap="round"
                              x1="46.9"
                              y1="53.2"
                              x2="59.2"
                              y2="53.2"
                            />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="attendance mb-4">
            <div className="row">
              <div className="col-lg-6">
                <div className="selectedLocations">
                  <div className="heading w-100 justify-content-between">
                    <span className="text1">Today’s Attendance</span>
                    <Select
                      value={selectedLocation}
                      onChange={handleChange}
                      options={locations}
                      placeholder="Select Location"
                      title={"123"}
                      styles={{
                        menu: (base) => ({
                          ...base,
                          width: "150px",
                        }),
                      }}
                    />
                  </div>
                  <div className="flex mb-3">
                    <div className="chart">
                      <Doughnut
                        data={data}
                        options={options}
                        plugins={[
                          createTextCenterPlugin(`${totalEmpLocation}`),
                        ]}
                        width="150px"
                        height="150px"
                      />
                    </div>
                    <div className="chart-counts">
                      {Array.isArray(attendanceCount.keys)
                        ? attendanceCount.keys.map((item) => {
                            return (
                              <React.Fragment key={item[0]}>
                                <div className={`chart-flex ${item[0]}`}>
                                  <div className="chart-content">
                                    <div className="circle"></div>
                                    <div className="content">
                                      <span>
                                        {item[0] === "onleave"
                                          ? "On Leave"
                                          : item[0] === "latemark"
                                            ? "Late Mark"
                                            : item[0] === "halfDay"
                                              ? "Half Day"
                                              : item[0] === "whf"
                                                ? "WFH"
                                                : item[0]}{" "}
                                        -
                                      </span>
                                    </div>
                                  </div>
                                  <div className="count">
                                    <span>
                                      {item[1] !== null ? item[1] : "0"}
                                    </span>
                                  </div>
                                </div>
                              </React.Fragment>
                            );
                          })
                        : null}
                    </div>
                  </div>
                  <div className="totalEmpCounts">
                    <span>Total Employees:</span>
                    <strong>{totalEmpLocation}</strong>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="allLocations">
                  <div className="heading">
                    <span className="text2">All Locations</span>
                  </div>
                  <div className="flex mb-3">
                    <div className="chart">
                      <Doughnut
                        data={data2}
                        options={options}
                        plugins={[
                          createTextCenterPlugin(`${totalEmpAllLocation}`),
                        ]}
                        width="150px"
                        height="150px"
                      />
                    </div>
                    <div className="chart-counts">
                      {Array.isArray(attendanceCountAll.keys)
                        ? attendanceCountAll.keys.map((item) => {
                            return (
                              <React.Fragment key={item[0]}>
                                <div className={`chart-flex ${item[0]}`}>
                                  <div className="chart-content">
                                    <div className="circle"></div>
                                    <div className="content">
                                      <span>
                                        {item[0] === "onleave"
                                          ? "On Leave"
                                          : item[0] === "latemark"
                                            ? "Late Mark"
                                            : item[0] === "halfDay"
                                              ? "Half Day"
                                              : item[0] === "whf"
                                                ? "WFH"
                                                : item[0]}{" "}
                                        -
                                      </span>
                                    </div>
                                  </div>
                                  <div className="count">
                                    <span>
                                      {item[1] !== null ? item[1] : "0"}
                                    </span>
                                  </div>
                                </div>
                              </React.Fragment>
                            );
                          })
                        : null}
                    </div>
                  </div>
                  <div className="totalEmpCounts">
                    <span>Total Employees:</span>
                    <strong>{totalEmpAllLocation}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`${
              event || sendWish ? "hr-events visible" : "hr-events"
            }`}
          >
            <div className="flex mb-3">
              <div className="left-flex">
                <span className="icon">
                  <MdEvent size={30} color="#4E465E" />
                </span>
                <span>Today’s Events</span>
              </div>
              <div className="right-flex">
                {/* <MonthCalendar
                  value={date}
                  onChange={handleDateChange}
                  view="date"
                  dateFormat="dd, MM, yy"
                  style={{ height: "100%" }}
                  showIcon
                  maxDate={maxDate}
                /> */}
              </div>
            </div>
            <div className="list">
              {Array.isArray(events)
                ? events.map((item) => {
                    return (
                      <React.Fragment key={item.id}>
                        <div className="item">
                          <div className="profile">
                            <div className="p-circle">
                              <span>
                                <img
                                  src={`https://elmsbk.aeontechhub.com/ProfilePic/${item.empId}/${item.profile}`}
                                  alt=""
                                />
                              </span>
                            </div>
                            <div className="name">
                              <span>{item.name}</span>
                            </div>
                            <div className="wish">
                              <span>{item.title}</span>
                            </div>
                            {/* <div className="action">
                              <button
                                onClick={(e) => {
                                  setSendWish(true);
                                }}
                              >
                                Send Wish
                              </button>
                            </div> */}
                          </div>
                        </div>
                      </React.Fragment>
                    );
                  })
                : null}
            </div>
            <div className="cakeIcon">
              <img src={CakeIcon} alt="" />
            </div>
          </div>

          <div
            className={`${event ? "modal-overlay" : ""}`}
            onClick={(e) => {
              setEvent(false);
            }}
          >
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <AddEvent />
            </div>
          </div>

          <div
            className={`${sendWish ? "modal-overlay" : ""}`}
            onClick={(e) => {
              setSendWish(false);
            }}
          >
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <SendWish />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HRDashboard;
